export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 5_10.6e717b37.jpg";